import { render, staticRenderFns } from "./offer-simple.vue?vue&type=template&id=c7aac6b4&lang=pug"
import script from "./offer-simple.vue?vue&type=script&lang=js"
export * from "./offer-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports